import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {Batteries} from '../pages/layout/list-batteries/list-batteries.component';
import {Userspayments} from '../pages/e-commerce/charts-panel/charts-panel.component'
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardpaymentsService {

  constructor(private afs: AngularFirestore) { }

  getUserspayments(){
    return this.afs.collection<Userspayments>(environment.env.EnvBaseUrl+'/'+environment.env.RidersPaymentDashboardCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Userspayments;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });;
  } 

  getYearlyearnings(){
    return this.afs.doc(environment.env.EnvBaseUrl+'/'+environment.env.TotalEarningsDashboardCollection+'/Yearly').snapshotChanges().pipe(map(action => {
      const data = action.payload.data();
      const id = action.payload.id;
      return { data };
    })
    );
  }
}